import { render } from "./register-page.vue?vue&type=template&id=366fd939"
import script from "./register-page.vue?vue&type=script&lang=js"
export * from "./register-page.vue?vue&type=script&lang=js"

import "./register-page.vue?vue&type=style&index=0&id=366fd939&lang=css"
script.render = render

export default script